import React from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  Typography,
} from '@mui/material';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';

/**
 * NodeTypeSelector - 建立節點前讓使用者選擇節點類型（一般節點 / 問卷節點）
 */
export const NodeTypeSelector = ({ open, onClose, onSelect }) => {
  const options = [
    {
      type: 'normal',
      icon: <ArticleOutlinedIcon sx={{ fontSize: 36 }} />,
      label: '一般節點',
      description: '記錄想法、觀點或任何內容',
    },
    {
      type: 'questionnaire',
      icon: <ListAltOutlinedIcon sx={{ fontSize: 36 }} />,
      label: '問卷節點',
      description: '設定問題，讓其他人填寫回答',
    },
  ];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ pb: 1 }}>選擇節點類型</DialogTitle>
      <DialogContent>
        <Box display="flex" gap={2} justifyContent="center" sx={{ pb: 1 }}>
          {options.map(({ type, icon, label, description }) => (
            <Button
              key={type}
              variant="outlined"
              onClick={() => {
                onClose();
                onSelect(type);
              }}
              sx={{
                flex: 1,
                flexDirection: 'column',
                gap: 1,
                py: 2.5,
                textTransform: 'none',
                borderRadius: 2,
              }}
            >
              {icon}
              <Typography variant="subtitle2" fontWeight="bold">
                {label}
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'normal', textAlign: 'center' }}>
                {description}
              </Typography>
            </Button>
          ))}
        </Box>
      </DialogContent>
    </Dialog>
  );
};
